import { defineStore } from 'pinia'
import { getContentPage } from '@/services/contentService'

export const useVisionMissionContentStore = defineStore('vissionMission', {
  state: () => ({
    contents: {
      vision: {},
      ourVision: {},
      innovative: {},
      flexible: {},
      ourCommitments: {},
      safety: {},
      sustainability: {},
      quality: {},
      ourCore: {},
      ourHistory: {},
      ourCommitment: {},
      leadership: {},
      leaderships: [],
      ourMission: {},
    },
    loading: false,
    error: null
  }),

  actions: {
    async fetchVisionMissionPage() {
      this.loading = true
      this.error = null

      try {
        const baseUploadURL = process.env.VUE_APP_API_URL;
        const visionContent = await getContentPage('Vision and Mission', 'A bold direction')
        const ourVisionContent = await getContentPage('Vision and Mission', 'Our Vision')
        const innovativeContent = await getContentPage('Vision and Mission', 'Innovative')
        const flexibleContent = await getContentPage('Vision and Mission', 'Flexible')
        const ourCommitmentsContent = await getContentPage('Vision and Mission', 'Our Commitments')
        const safetyContent = await getContentPage('Vision and Mission', 'Safety')
        const sustainabilityContent = await getContentPage('Vision and Mission', 'Sustainability')
        const qualityContent = await getContentPage('Vision and Mission', 'Quality')
        const ourCoreContent = await getContentPage('Vision and Mission', 'Our Core Values')
        const leadershipContent = await getContentPage('About Us', 'Leadership')
        const leadershipList = await getContentPage('Home', 'Item Leadership')

        const mapVisionContent = await Promise.all(
          visionContent.map(async item => ({
            ...item,
            image: item.banner
              ? baseUploadURL + item.banner.uploadFile
              : null,
          }))
        )

        const mapOurVisionContent = await Promise.all(
          ourVisionContent.map(async item => ({
            ...item,
            image: item.banner
              ? baseUploadURL + item.banner.uploadFile
              : null,
          }))
        )

        const mapOurCoreContent = await Promise.all(
          ourCoreContent.map(async item => ({
            ...item,
            image: item.banner
              ? baseUploadURL + item.banner.uploadFile
              : null,
          }))
        )

        const mapLeadershipList = await Promise.all(
          leadershipList.map(async item => ({
            ...item,
            image: item.banner
              ? baseUploadURL + item.banner.uploadFile
              : null,
          }))
        )

        this.contents.vision = mapVisionContent[0]
        this.contents.ourVision = mapOurVisionContent[0]
        this.contents.innovative = innovativeContent[0]
        this.contents.flexible = flexibleContent[0]
        this.contents.ourCommitments = ourCommitmentsContent[0]
        this.contents.safety = safetyContent[0]
        this.contents.sustainability = sustainabilityContent[0]
        this.contents.quality = qualityContent[0]
        this.contents.ourCore = mapOurCoreContent[0]
        this.contents.leadership = leadershipContent[0]
        this.contents.leaderships = mapLeadershipList

        // console.log(this.contents.vision)
        // console.log(this.contents.ourVision)
        // console.log(this.contents.innovative)
        // console.log(this.contents.flexible)
        // console.log(this.contents.ourCommitments)
        // console.log(this.contents.safety)
        // console.log(this.contents.sustainability)
        // console.log(this.contents.quality)
        // console.log(this.contents.ourCore)
        // console.log(this.contents.leadership)
        // console.log(this.contents.leaderships)
      } catch (err) {
        this.error = err.message
      } finally {
        this.loading = false
      }
    }
  }
})